module.exports = __webpack_public_path__ + "static/customer-workflow-management-cff32dc26460298c847da520833b36d2.png";